import React from 'react';

import Row from 'components/Common/Row';
import DragAndDropList from 'components/DragAndDropList';
import Typography from 'kingpin/atoms/Typography';
import FieldItem from './FieldItem';
import { Col } from './styles';

const FieldsGrid = ({
  searchText,
  filteredColumns,
  columnOrder,
  updateColumnsOrder,
}: {
  searchText: string;
  filteredColumns: PerformanceBoardTypes.Column[];
  columnOrder: PerformanceBoardTypes.Column[];
  updateColumnsOrder: ({
    newOrder,
  }: {
    newOrder: PerformanceBoardTypes.Column[];
  }) => void;
}) => {
  return (
    <>
      <Row
        centerAlign
        style={{
          height: '40px',
          padding: '8px',
          position: 'sticky',
          top: 0,
          backgroundColor: 'var(--color-bg-muted)',
          border: `1px solid var(--color-grey-8)`,
          margin: '-1px 0',
        }}
      >
        <Col width={73} centerAlign>
          <Typography.Body type="Body 12">#</Typography.Body>
        </Col>
        <Col width={225}>
          <Typography.Body type="Body 12">Field Name</Typography.Body>
        </Col>
        <Col width={73} centerAlign>
          <Typography.Body type="Body 12">Hidden</Typography.Body>
        </Col>
        <Col width={73} centerAlign>
          <Typography.Body type="Body 12">Displayed</Typography.Body>
        </Col>
      </Row>
      <DragAndDropList
        items={filteredColumns}
        onOrderChanged={(newOrder) => updateColumnsOrder({ newOrder })}
        droppableId="fieldId"
        renderItem={(column) => (
          <FieldItem
            column={column}
            searchText={searchText}
            columnOrder={columnOrder}
            updateColumnsOrder={updateColumnsOrder}
          />
        )}
      />
    </>
  );
};

export default FieldsGrid;
